
import { t } from "@/plugins/i18n";
export interface DimensionListReportFilter {
  yearId: number;
  fromDimcode: string;
  toDimcode: string;
  statusId: number;
  typeId: number;
}

export const DefaultDimensionListReportFilter: DimensionListReportFilter = {
  yearId: 0,
  fromDimcode: "",
  toDimcode: "",
  statusId: 0,
  typeId: 0,
};

export interface DimensionStatusOption {
  id: number;
  name: string;
}

// "Összes" opció, amit a backendről jövő valós állapotok elé fűzünk (0 = nincs szűrés).
export const AllStatusesOption: DimensionStatusOption = { id: 0, name: t("Osszes") };
